export default __webpack_public_path__ + "static/media/dashboard-alt.89cb76ee.png";